import { EXPRESSION_LANE_HEIGHT, MIN_PROFILE_TOP_SPACE } from "@/settings/settings.ts";

import { type IPileup } from "./track-pileup-factory.js";

export function getPileupHeight(pileup: IPileup) {
  if (!pileup) return 0;

  const { featureHeight, labelHeight, lanePadding, hideLabels } = pileup.pileupParams;
  const expressionLaneHeight = EXPRESSION_LANE_HEIGHT * (pileup.expressionLaneNumber ?? 0); // Variant track doesn't have expressions
  let pileupHeight =
    Math.max(pileup.lanes, 1) * (featureHeight + (hideLabels ? 0 : labelHeight) + expressionLaneHeight) +
    (pileup.lanes - 1) * lanePadding;

  if (pileup.variants) {
    pileupHeight = Math.max(pileupHeight, MIN_PROFILE_TOP_SPACE);
  }

  return pileupHeight;
}
